export const REJECTION_STATUS = {
  ALL: 'ALL',
  REJECTED: 'REJECTED',
  NON_REJECTED: 'NON_REJECTED',
} as const;
